import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { UserRoleGuard } from './core/guards/userRole.guard';
import { Role } from './core/models/role';
import { LoginComponent } from './modules/auth/login/login.component';


const appRoutes: Routes = [
  {
    path: 'login',
    // canActivate: [UserRoleGuard],
    data: { roles: ['login'] },
    component: LoginComponent
  },
  {
    path: 'resetPassword',
    // canActivate: [UserRoleGuard],
    data: { roles: ['resetPassword'] },
    loadChildren: () => 
      import('./modules/resetPassword/resetPassword.module').then(mod => mod.ResetPasswordModule)
  },
  {
    path: '',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.USER] },
    loadChildren: () =>
      import('./modules/client/client.module').then(mod => mod.ClientModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.FILIALADMIN] },
    loadChildren: () =>
      import('./modules/filialAdmin/filialAdmin.module').then(mod => mod.FilialAdminModule)
  },
  {
    path: 'worker',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.WORKER] },
    loadChildren: () =>
      import('./modules/worker/worker.module').then(mod => mod.WorkerModule)
  },
  {
    path: 'root',
    canActivate: [AuthGuard, UserRoleGuard],
    data: {
      roles: [Role.ROOT],
      breadcrumb: { skip: true }
    },
    loadChildren: () =>
      import('./modules/root/root.module').then(mod => mod.RootModule)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
